<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FINANCEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FINANCEDATE),
      }"
    >
      <mat-label>Finance Date</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'FINANCEDATE')"
        matTooltip="{{ toolTipList ? toolTipList.FINANCEDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="FINANCEDATETEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'FINANCEDATE')"
        matInput
        name="FinanceDate"
        [matDatepicker]="FinanceDate"
      />
      <mat-datepicker-toggle matSuffix [for]="FinanceDate"></mat-datepicker-toggle>
      <mat-datepicker #FinanceDate></mat-datepicker>
      @if (testBool && toolTipList.FINANCEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.FINANCEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.FINANCEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BANKREFERENCE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BANKREFERENCE),
      }"
    >
      <mat-label>Bank Ref</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.BANKREFERENCE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BANKREFERENCE"
      />
      @if (testBool && toolTipList.BANKREFERENCE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.BANKREFERENCE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BANKREFERENCE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" class="checkbox-row" fxFlex="1 0 auto">
    <mat-checkbox formControlName="BUILDINGREPORTCOMPLETED" class="checkbox-width pr-1">
      Building Report Completed
    </mat-checkbox>
    <mat-checkbox formControlName="PESTREPORTCOMPLETED" class="checkbox-width pr-1">
      Pest Report Completed
    </mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100" class="pr-1"
        [ngClass]="{'has-error':errorWarningData.Error?.SPECIALCONDITIONS,'has-warning':errorWarningData.Warning?.SPECIALCONDITIONS}">
        <mat-label> Special Conditions</mat-label>
        <textarea matInput
          matTooltip="{{(toolTipList)?toolTipList.SPECIALCONDITIONS?.HOVER:''}}"
          [matTooltipPosition]="toolTipPostion"
        formControlName="SPECIALCONDITIONS"></textarea> -->

    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.SPECIALCONDITIONS),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.SPECIALCONDITIONS),
      }"
    >
      <mat-label>Special Conditions</mat-label>

      <textarea
        matInput
        formControlName="SPECIALCONDITIONS"
        [matTooltip]="toolTipList?.SPECIALCONDITIONS?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList.SPECIALCONDITIONS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.SPECIALCONDITIONS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.SPECIALCONDITIONS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <!-- </mat-form-field> -->
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYABLEBYPURCHASER),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYABLEBYPURCHASER),
      }"
    >
      <mat-label>Payable By Purchaser</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PAYABLEBYPURCHASER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PAYABLEBYPURCHASER"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.PAYABLEBYPURCHASER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PAYABLEBYPURCHASER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.PAYABLEBYPURCHASER?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.PAYABLEBYVENDOR),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.PAYABLEBYVENDOR),
      }"
    >
      <mat-label>Payable By Vendor</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.PAYABLEBYVENDOR?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="PAYABLEBYVENDOR"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.PAYABLEBYVENDOR) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.PAYABLEBYVENDOR.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.PAYABLEBYVENDOR?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(
          errorWarningData.Error?.TOTALFUNDSREQUIREDFROMPURCHASER
        ),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.TOTALFUNDSREQUIREDFROMPURCHASER
        ),
      }"
    >
      <mat-label>Total Funds Required By Purchaser</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.TOTALFUNDSREQUIREDFROMPURCHASER?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="TOTALFUNDSREQUIREDFROMPURCHASER"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.TOTALFUNDSREQUIREDFROMPURCHASER) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TOTALFUNDSREQUIREDFROMPURCHASER.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(
                      toolTipList?.TOTALFUNDSREQUIREDFROMPURCHASER?.COPYVALUE
                    )
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALDUE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALDUE),
      }"
    >
      <mat-label>Total Due</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.TOTALDUE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="TOTALDUE"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.TOTALDUE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.TOTALDUE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TOTALDUE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.CHEQUESDUE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.CHEQUESDUE),
      }"
    >
      <mat-label>Payment Due</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.CHEQUESDUE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="CHEQUESDUE"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.CHEQUESDUE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.CHEQUESDUE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.CHEQUESDUE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.UNPAIDAMOUNT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.UNPAIDAMOUNT),
      }"
    >
      <mat-label>Unpaid Amount</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList.UNPAIDAMOUNT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="UNPAIDAMOUNT"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList.UNPAIDAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.UNPAIDAMOUNT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.UNPAIDAMOUNT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.VENDORPAYS),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.VENDORPAYS),
      }"
    >
      <mat-label>Who pays for settlement day?</mat-label>
      <mat-select
        matTooltip="{{ toolTipList ? toolTipList.VENDORPAYS?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="VENDORPAYS"
      >
        <mat-option value="System Default">System Default</mat-option>
        <mat-option value="Vendor Pays">Vendor Pays</mat-option>
        <mat-option value="Purchasor Pays">Purchasor Pays</mat-option>
      </mat-select>
      @if (testBool && toolTipList.VENDORPAYS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.VENDORPAYS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.VENDORPAYS?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="50"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DATEPAID),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DATEPAID),
      }"
    >
      <mat-label>Date Paid</mat-label>
      <input
        (dateInput)="CommanDatePickerClick('input', $event, 'DATEPAID')"
        matTooltip="{{ toolTipList ? toolTipList.DATEPAID?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DATEPAIDTEXT"
        (dateChange)="CommanDatePickerClick('input', $event, 'DATEPAID')"
        matInput
        name="DatePaid"
        [matDatepicker]="DatePaid"
      />
      <mat-datepicker-toggle matSuffix [for]="DatePaid"></mat-datepicker-toggle>
      <mat-datepicker #DatePaid></mat-datepicker>
      @if (testBool && toolTipList.DATEPAID) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList.DATEPAID.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DATEPAID?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <!-- *ngIf="MatterData.classType == 4" -->
  @if (
    MatterData == 'Property Purchase' ||
    MatterData == 'Property Sale' ||
    MatterData == 'Business Sale' ||
    MatterData == 'Business Purchase'
  ) {
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <mat-form-field appearance="outline" fxFlex="25" class="pr-1">
        <mat-label><b>Settlement time</b></mat-label>
        <input
          type="text"
          matInput
          aria-label="Number"
          matTooltip="{{ toolTipList ? toolTipList.SETTLEMENTTIME?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="SETTLEMENTTIME"
          name="SETTLEMENTTIME"
          (dateInput)="CommanDatePickerClick('input', $event, 'SETTLEMENTTIME')"
        />
        @if (testBool && toolTipList.SETTLEMENTTIME) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.SETTLEMENTTIME.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.SETTLEMENTTIME?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="75" class="pr-1">
        <mat-label><b>Settlement Location</b></mat-label>
        <input
          matInput
          matTooltip="{{ toolTipList ? toolTipList.SETTLEMENTLOCATION?.HOVER : '' }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="SETTLEMENTLOCATION"
          name="SETTLEMENTLOCATION"
        />
        @if (testBool && toolTipList.SETTLEMENTLOCATION) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList ? toolTipList.SETTLEMENTLOCATION.COPYVALUE : '' }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  toolTipList
                    ? $safeNavigationMigration(toolTipList?.SETTLEMENTLOCATION?.COPYVALUE)
                    : ''
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    </div>
  }

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- Always visible -->
    <mat-form-field appearance="outline" fxFlex="33" class="pr-1">
      <mat-label>Building Inspection Date</mat-label>
      <input
        matInput
        [matDatepicker]="pickerBuilding"
        matTooltip="{{ toolTipList?.BUILDINGINSPECTIONDATE?.HOVER }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="BUILDINGINSPECTIONDATETEXT"
        (dateInput)="CommanDatePickerClick('input', $event, 'BUILDINGINSPECTIONDATE')"
      />
      <mat-datepicker-toggle matSuffix [for]="pickerBuilding"></mat-datepicker-toggle>
      <mat-datepicker #pickerBuilding></mat-datepicker>
      @if (testBool && toolTipList.BUILDINGINSPECTIONDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList?.BUILDINGINSPECTIONDATE?.COPYVALUE }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                $safeNavigationMigration(toolTipList?.BUILDINGINSPECTIONDATE?.COPYVALUE)
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>

    <!-- Conditionally visible fields -->
    @if (
      MatterData == 'Property Purchase' ||
      MatterData == 'Property Sale' ||
      MatterData == 'Business Sale' ||
      MatterData == 'Business Purchase'
    ) {
      <mat-form-field appearance="outline" fxFlex="33" class="pr-1">
        <mat-label>Pest Inspection Date</mat-label>
        <input
          matInput
          [matDatepicker]="pickerPest"
          matTooltip="{{ toolTipList?.PESTINSPECTIONDATE?.HOVER }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="PESTINSPECTIONTEXT"
          (dateInput)="CommanDatePickerClick('input', $event, 'PESTINSPECTIONDATE')"
        />
        <mat-datepicker-toggle matSuffix [for]="pickerPest"></mat-datepicker-toggle>
        <mat-datepicker #pickerPest></mat-datepicker>
        @if (testBool && toolTipList.PESTINSPECTIONDATE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList?.PESTINSPECTIONDATE?.COPYVALUE }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  $safeNavigationMigration(toolTipList?.PESTINSPECTIONDATE?.COPYVALUE)
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
      <mat-form-field appearance="outline" fxFlex="34" class="pr-1">
        <mat-label>Pool Inspection Date</mat-label>
        <input
          matInput
          [matDatepicker]="pickerPool"
          matTooltip="{{ toolTipList?.POOLINSPECTIONDATE?.HOVER }}"
          [matTooltipPosition]="toolTipPostion"
          formControlName="POOLINSPECTIONTEXT"
          (dateInput)="CommanDatePickerClick('input', $event, 'POOLINSPECTIONDATE')"
        />
        <mat-datepicker-toggle matSuffix [for]="pickerPool"></mat-datepicker-toggle>
        <mat-datepicker #pickerPool></mat-datepicker>
        @if (testBool && toolTipList.POOLINSPECTIONDATE) {
          <div class="tooltip-wrap">
            <input
              id="myInput"
              readonly
              disabled
              value="{{ toolTipList?.POOLINSPECTIONDATE?.COPYVALUE }}"
            />
            <mat-icon
              (click)="
                tooltipService.copyTooltipText(
                  $safeNavigationMigration(toolTipList?.POOLINSPECTIONDATE?.COPYVALUE)
                )
              "
            >
              file_copy
            </mat-icon>
          </div>
        }
      </mat-form-field>
    }
  </div>
</div>
